/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
/**
 * Service for exposing platform-specific functionality and data
 */
export class PlatformService {
  constructor(@Inject(PLATFORM_ID) platformId: Object, private router: Router) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  // PROPERTIES
  public isBrowser: boolean = false;

  /**
   * Whether the current device is a mobile device or not
   */
  public get isMobile(): boolean {
    return (
      'maxTouchPoints' in navigator &&
      navigator.maxTouchPoints > 0 &&
      window.innerWidth <= 768
    );
  }

  /**
   * The absolute URL for the current route, or the route if its already absolute
   * @param route Optional route to generate the absolute URL for. If not provided, the page's current route is used
   */
  public getAbsoluteURL(route?: string): string {
    const isRelative =
      !!route?.startsWith?.('/') || !!route?.startsWith?.('./');

    if (isRelative || !route) {
      return route ?? this.router.url;
    }
    return route;
  }
}
